export enum PointTypeEnum {
    RECEPTION_PLACE = 0,
    CONTAINER = 1,
    INTERNAL_STORE = 2,
    RECEPTION_PLACE_LOCALIZATION = 3,
    INTERNAL_STORE_BORDER_POINT = 4
}